export const AUTHENTICATION_TOKEN_KEY = 'ss_token';
export const METRICS_KEY = 'ss_metrics';
export const ACCOUNT_SELECTED_KEY = 'accountSelected';
export const DASHBOARDS_KEY = 'dashboards';
export const GDPR_COOKIE_KEY = 'gdpr';
export const COMPANY_URI = 'ss_company_uri';
export const COMPANY_URLS = 'ss_company_urls';
export const EXPLORE_GROUP_BY = 'exploreGroupBy';
export const AUTHENTICATION_TOKEN_REFRESH = 'refreshToken';
